<template>
  <div
    class="analysisItem"
    ref="analysisItemRef"
    :style="
      `top:${moveTop}px;transition:${isDragging ? '0' : '.3s'}s;${
        isDragging ? 'z-index:999;' : ''
      }${isDrag ? 'cursor:move' : ''}`
    "
    @mousedown="moveDown($event)"
  >
    <div class="ai-header">
      <div
        class="ai-h-left"
        :style="`${isDrag ? 'cursor:move' : ''}`"
        @click="changeOpenItem(!openItem)"
      >
        <span
          :class="['ai-h-l-icon', openItem ? 'ai-h-l-iconActive' : '']"
        ></span>
        <span class="ai-h-l-text" v-if="!editTitle">{{
          data.jsonData.anotherName
            ? data.jsonData.anotherName
            : data.jsonData.name
        }}</span>
        <div class="a_h_l_t_input" v-if="editTitle" @click.stop="() => {}">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            @submit.native.prevent
          >
            <el-form-item prop="name">
              <el-input
                v-model="form.name"
                @blur="editNameCheckFn()"
                @keyup.enter.native="editNameCheckFn()"
                ref="editNameInputRef"
                placeholder="请输入新的名称"
              ></el-input>
            </el-form-item>
            <!--   @blur="editNameCheckFn()" -->
          </el-form>
        </div>
        <el-tooltip
          v-if="!editTitle"
          class="item"
          effect="light"
          content="修改名称"
          placement="top"
        >
          <span class="a_h_l_edit" @click.stop="editTitleFn()" v-if="!isDrag">
            <img
              src="../../../../assets/icon/classroomObservation/editIcon2.svg"
            />
          </span>
        </el-tooltip>
      </div>
      <div class="ai-h-right">
        <span
          style="width: 100px;"
          class="generateError"
          v-if="loadNum == 2 && !isDrag"
          >优化失败
        </span>
        <span style="width: 100px" v-if="loadNum == 1 && !isDrag">
          <span v-if="loading" class="generate">
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/generate.svg')
              "
            />
            生成中...
          </span>
          <span v-else class="generateSuccess">
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/success.svg')
              "
            />
            生成完成
          </span>
        </span>

        <span
          v-if="loadNum == 0 && !openItem && tid && !isDrag"
          class="ai-h-r-icon4"
          @click="delBtn()"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="删除"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/del.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum == 0 && openItem && !isDrag"
          :class="['ai-h-r-icon1', showIndex <= 0 ? 'ai_h_r_iconOpacity' : '']"
          @click="changeShowIndex(-1)"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="上一个"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/back.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum != 1 && openItem && !isDrag"
          :class="[
            showIndex >= historyResult.length - 1 ? 'ai_h_r_iconOpacity' : ''
          ]"
          @click="changeShowIndex(1)"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="下一个"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/back.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum != 1 && openItem && tid && !isDrag"
          @click="editBtn()"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="优化"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/edit.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="
            loadNum != 1 &&
              openItem &&
              tid &&
              ['1', '2', '3'].includes(data.jsonData.echartsType) &&
              !isDrag
          "
          @click="editEcharts()"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="生成图表"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/echartIcon.svg')
              "
            />
          </el-tooltip>
        </span>

        <!-- <span class="ai-h-r-icon4" @click.stop="delBtn()"></span> -->
      </div>
    </div>
    <div class="ai-main" v-if="openItem && !isDrag">
      <div class="a-m-brief" v-if="showBrief">
        {{ data.jsonData.result }}
        <!-- <mdView :text="data.jsonData.result" /> -->
        <!-- {{ data.jsonData.result }} -->
      </div>

      <eChartTemplate
        style="width: 100%;height: 400px;"
        :data="data.jsonData.eChartData"
        v-if="data.jsonData.eChartData"
      />
      <mdView :text="data.jsonData.content" />
      <div v-for="(item, index) in data.jsonData.dataFileList" :key="item.uid">
        <div v-if="imgTypeList.includes(checkFileType(item.url))">
          <img style="max-width: 100%" :src="item.url" alt="" />
        </div>
        <div v-else-if="checkFileType(item.url) == 'md'">
          <mdView :url="item.url" />
        </div>
        <div v-else-if="checkFileType(item.url) == 'json'">
          <pieChart :url="item.url" />
        </div>
      </div>

      <div v-for="(item, index) in data.jsonData.fileList" :key="item.uid">
        <div v-if="imgTypeList.includes(checkFileType(item.url))">
          <img style="max-width: 100%" :src="item.url" alt="" />
        </div>
        <div v-else-if="checkFileType(item.url) == 'md'">
          <mdView :url="item.url" />
        </div>
        <div v-else-if="checkFileType(item.url) == 'json'">
          <pieChart :url="item.url" />
        </div>
      </div>
    </div>
    <!-- <editNameDialog ref="editNameDialogRef" @success="changeNameSuccess"/> -->
  </div>
</template>

<script>
import mdView from "./mdView.vue";
import pieChart from "./pieChart.vue";
import { v4 as uuidv4 } from "uuid";
import eChartTemplate from "./eChartTemplate";
import markdownIt from "markdown-it";
// import editNameDialog from './editNameDialog.vue'
export default {
  emits: ["delItem", "editItem", "saveItem"],
  components: {
    mdView,
    pieChart,
    eChartTemplate
    // editNameDialog
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dialogTagDataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    tid: {
      type: String,
      require: true
    },
    fileId: {
      type: String,
      require: true
    },
    showBrief: {
      type: Boolean,
      default: true
    },
    bmData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isDrag: {
      type: Boolean,
      default: false
    },
    dialogTagList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      openItem: false,
      loading: false,
      loadNum: 0,
      userId: this.$route.query["userid"],
      showIndex: 0,
      historyResult: [],
      imgTypeList: [
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif",
        "webp",
        "psd",
        "svg",
        "tiff"
      ],
      oldData: {},
      form: {
        name: ""
      },
      editTitle: false,
      rules: {
        name: [
          { required: true, trigger: "change", message: "请输入新的名称" },
          {
            min: 1,
            max: 20,
            trigger: "change",
            message: "长度需在1-20个字符之间"
          }
        ]
      },
      startY: 0,
      startTop: 0,
      moveTop: 0,
      isDragging: false,
      dragBoxList: [],
      enterDrag: null
    };
  },
  computed: {
    checkFileType() {
      return url => {
        return url.split(".").pop();
      };
    }
  },
  watch: {
    // showIndex(){
    // 	let _copyData = JSON.parse(JSON.stringify(this.data));
    // 	_copyData.jsonData = this.historyResult[this.showIndex];
    // 	_copyData.json_data = JSON.stringify(_copyData.jsonData);
    // 	this.$emit("editItem", this.data.id, _copyData);
    // }
  },
  methods: {
    changeOpenItem(newValue) {
      if (this.isDrag) return;
      if (this.loading == true && this.loadNum != 0)
        return this.$message("请稍后...");
      this.loadNum = 0;
      this.openItem = newValue;
    },
    editBtn() {
      this.$nextTick(() => {
        this.loading = true;
        this.openItem = false;
        this.loadNum = 1;
        let type = 0; //0 用agentId  1:用提示词 3:啥都没有
        let tips = "";
        let assistant =
          this.dialogTagDataList.find(i => i.id == this.data.jsonData.mId) ||
          this.dialogTagDataList.find(i => i.name == this.data.jsonData.name);

        let _msg = `使用文件检索的方式完整的去分析文件内容，并请完全按照要求输出。`;

        if (!assistant) {
          this.loading = false;
          this.loadNum = 2;
          type = 3;
          return this.$message.error("未找到对应的AI助手");
        }

        if (assistant.tips) {
          type = 1;
          let analysisData = ``;
          for (let i = 0; i < this.dataList.length; i++) {
            let _json = this.dataList[i].jsonData;
            analysisData += `### ${
              _json.anotherName ? _json.anotherName : _json.name
            }\n`;
            analysisData += `${_json.content}\n`;
          }
          tips = assistant.tips.replaceAll("${analysisData}", analysisData);
        } else if (assistant.agentid) {
          type = 0;
        } else {
          this.loading = false;
          this.loadNum = 2;
          type = 3;
          return this.$message.error("未找到对应的AI助手");
        }

        if (assistant.agentid == "6b4a9650-48be-11ef-936b-12e77c4cb76b") {
          _msg = `使用文件检索的方式完整的去分析文件内容，并基于以下的课堂基本内容，使用cpote课程设计模型改编一堂同主题的课程。
课堂名称：${this.bmData.courseName}  搜课年级：${this.bmData.grade}  授课科目：${this.bmData.subject}`;
        }

        // console.log('👇')
        // return console.log(_msg)
        let parm = {
          assistant_id:
            type == 0
              ? assistant.agentid
              : "f8e1ebb2-2e0d-11ef-8bf4-12e77c4cb76b",
          message: type == 0 ? _msg : tips,
          session_name: uuidv4(),
          userId: this.userId,
          file_ids: this.fileId ? [this.fileId] : "",
          model: "gpt-4o-2024-11-20"
          // model: "gpt-4o-mini"
        };

        // 👇
        // const _uid = uuidv4();
        // let parm = {
        // 	assistant_id: assistant ? assistant.value : null,
        // 	userId: this.userId, //602def61-005d-11ee-91d8-005056b86db5
        // 	message:
        // 		"请使用代码解析器获取文件，帮我根据要求完整的分析，输出请按照要求。",
        // 	session_name: new Date().getTime(),
        // 	uid: _uid,
        // 	file_ids: this.fileId ? [this.fileId] : [],
        // };
        if (!parm.assistant_id) {
          this.loading = false;
          this.loadNum = 2;
          return this.$message.error("未找到对应的AI助手");
        }
        // this.ajax
        // 	.post("https://gpt4.cocorobo.cn/ai_agent_park_chat_new", parm)
        // 	.then((res) => {
        // 		if (res.data.FunctionResponse.result == "发送成功") {
        // 		} else {
        // 			this.$message.warning(res.data.FunctionResponse.result);
        // 		}
        // 	})
        // 	.catch((err) => {
        // 		console.log(err);
        // 	});
        // this.getAtAuContent(_uid);
        // 👆

        this.ajax
          .post("https://gpt4.cocorobo.cn/ai_agent_park_chat", parm)
          .then(res => {
            let _data = res.data.FunctionResponse;
            // if (
            // 	!_data.message ||
            // 	_data.message.indexOf("由于我无法直接访问您上传的文件内容") > -1
            // ) {
            // 	this.loading = false;
            // 	this.loadNum = 2;
            // 	// this.$message.error("AI无法识别优化");
            // 	return
            // }
            let _copyData = JSON.parse(JSON.stringify(this.data));
            // _copyData.jsonData.result = "";
            if (!_copyData.jsonData.mId && assistant.agentid)
              _copyData.jsonData.mId = assistant.agentid;
            _copyData.jsonData.content = _data.message;
            _copyData.jsonData.dataFileList = [];
            _copyData.jsonData.fileList = [];
            _copyData.json_data = JSON.stringify(_copyData.jsonData);
            if (this.historyResult.length == 0) {
              this.historyResult.push(_copyData.jsonData);
            } else {
              this.historyResult.splice(
                this.showIndex + 1,
                0,
                _copyData.jsonData
              );
            }
            this.changeShowIndex(1);
            this.loading = false;
            this.$nextTick(() => {
              if (
                this.data.jsonData.echartsType &&
                ["1", "2", "3"].includes(this.data.jsonData.echartsType)
              ) {
                this.editEcharts();
              }
            });
          })
          .catch(err => {
            this.loadNum = 2;
            // this.$message.error("AI无法识别优化");
            this.loading = false;
          });
      });
    },
    getAtAuContent(_uid, _text, _headUrl, _assistantName) {
      let _source = new EventSource(
        `https://gpt4.cocorobo.cn/question/${_uid}`
      ); //http://gpt4.cocorobo.cn:8011/question/   https://gpt4.cocorobo.cn/question/
      let _allText = "";
      let _mdText = "";
      let _copyData = JSON.parse(JSON.stringify(this.data));
      // _copyData.jsonData.result = "";
      _copyData.jsonData.content = "";
      _copyData.jsonData.dataFileList = [];
      _copyData.jsonData.fileList = [];
      if (this.historyResult.length == 0) {
        this.historyResult.push(_copyData.jsonData);
      } else {
        this.historyResult.splice(this.showIndex + 1, 0, _copyData.jsonData);
      }
      this.showIndex++;
      this.$emit("editItem", this.data.id, _copyData);
      // const md = new MarkdownIt();
      _source.onmessage = _e => {
        let _eData = JSON.parse(_e.data);
        if (_eData.content.replace("'", "").replace("'", "") == "[DONE]") {
          let _result = [];
          if ("result" in _eData) {
            _result = _eData.result;
            for (let i = 0; i < _result.length; i++) {
              _mdText = _mdText.replace(_result[i].text, _result[i].fileName);
            }
          }
          _mdText = _mdText.replace("_", "");
          _copyData.jsonData.content = _mdText;
          this.loading = false;
          this.loadNum = 0;
          this.$emit("editItem", this.data.id, _copyData);
          this.$emit("saveItem", this.data.id, _copyData);
          _source.close();
        } else {
          let _text = _eData.content.replace("'", "").replace("'", "");
          if (_allText == "") {
            _allText = _text.replace(/^\n+/, ""); //去掉回复消息中偶尔开头就存在的连续换行符
          } else {
            _allText += _text;
          }
          _mdText = _allText + "_";
          _mdText = _mdText.replace(/\\n/g, "\n");
          _mdText = _mdText.replace(/\\/g, "");
          if (_allText.split("```").length % 2 == 0) _mdText += "\n```\n";
          //转化返回的回复流数据
          // _mdText = md.render(_mdText);
          _copyData.jsonData.content = _mdText;
          this.$emit("editItem", this.data.id, _copyData);
          // 处理流数据
        }
      };
    },
    delBtn() {
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.$emit("delItem", this.data.id);
        })
        .catch(_ => {
          console.log("取消");
        });
    },
    changeShowIndex(value) {
      if (this.historyResult.length == 0) return;
      if (value == -1) {
        if (this.showIndex > 0) this.showIndex--;
      } else if (value == 1) {
        if (this.showIndex < this.historyResult.length - 1) this.showIndex++;
      }
      let _copyData = JSON.parse(JSON.stringify(this.data));
      let _oldCopyDate = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData = this.historyResult[this.showIndex];
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      _oldCopyDate.json_data = JSON.stringify(_oldCopyDate.jsonData);
      // 一样就不用更新了
      if (JSON.stringify(_copyData) == JSON.stringify(_oldCopyDate)) return;
      // this.data = _copyData;
      this.$emit("editItem", this.data.id, _copyData);
      this.$emit("saveItem", this.data.id, _copyData);
    },
    // editTitle(){
    // 	this.$refs.editNameDialogRef.open(this.data.jsonData.anotherName?this.data.jsonData.anotherName:this.data.jsonData.name)
    // },
    changeNameSuccess(newName) {
      let _copyData = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData.anotherName = newName;
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      this.$emit("editItem", this.data.id, _copyData);
      this.$emit("saveItem", this.data.id, _copyData);
      // this.$refs.editNameDialogRef.close();
    },
    editTitleFn() {
      if (!this.tid) return this.$message.info("请新建课堂，或选择历史课堂");
      this.form.name = this.data.jsonData.anotherName
        ? this.data.jsonData.anotherName
        : this.data.jsonData.name;
      this.editTitle = true;
      this.$nextTick(() => {
        this.$refs.editNameInputRef.focus();
      });
      // this.$refs.editNameDialogRef.open(this.title)
    },
    editNameCheckFn() {
      if (!this.editTitle) return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.editTitle = false;
          this.changeNameSuccess(this.form.name);
        } else {
          this.$nextTick(() => {
            this.$refs.editNameInputRef.focus();
            this.$message.error("该名称不符合规则");
          });
        }
      });
    },
    editEcharts() {
      this.loading = true;
      this.loadNum = 1;
      this.openItem = false;
      if (this.data.jsonData.echartsType == "1") {
        //词云图
        return this.getContentTable().then(res => {
          try {
            if (res.length <= 0) {
              this.loadNum = 2;
              this.loading = false;
              return this.$message.error("在正文中未找到表格数据");
            }

            let _result = [];
            res.forEach((item, index) => {
              if (index == 0) return; //去掉表头
              let _valueItem = item[2] ? item[2] : item[1];
              let _value = _valueItem.match(/(\d+)/);
              _value = _value ? parseInt(_value[0]) : 0;
              _result.push({
                value: _value,
                name: item[0],
                textStyle: { color: this.getRandomColor() }
              });
            });

            let _option = {
              tooltip: {
                show: false
              },
              series: [
                {
                  type: "wordCloud",
                  sizeRange: [14, 38],
                  rotationRange: [0, 0],
                  keepAspect: false,
                  shape: "circle",
                  left: "center",
                  top: "center",
                  right: null,
                  bottom: null,
                  width: "100%",
                  height: "100%",
                  // rotationRange: [-90, 90],
                  rotationStep: 20,
                  data: _result
                }
              ]
            };
            let _copyData = JSON.parse(JSON.stringify(this.data));
            _copyData.jsonData.eChartData = _option;
            _copyData.json_data = JSON.stringify(_copyData.jsonData);
            if (this.historyResult.length == 0) {
              this.historyResult.push(_copyData.jsonData);
            } else {
              this.historyResult.splice(
                this.showIndex + 1,
                0,
                _copyData.jsonData
              );
            }
            this.changeShowIndex(1);
            this.loading = false;
          } catch (e) {
            console.log(e);
            this.loadNum = 2;
            this.loading = false;
            this.$message.error("生成图表失败");
          }
        });
      } else if (this.data.jsonData.echartsType == "2") {
        //雷达图
        //雷达图
        return this.getContentTable().then(res => {
          try {
            if (res.length <= 0) {
              this.loadNum = 2;
              this.loading = false;
              return this.$message.error("在正文中未找到表格数据");
            }

            let radarData = [];
            let seriesData = { value: [] };

            res.forEach((item, index) => {
              if (index == 0) return; //去掉表头
              radarData.push({ name: item[0], max: 5 });
              let _valueItem = item[1] ? item[1] : "0";
              let _value = _valueItem.match(/(\d+)/);
              _value = _value ? parseInt(_value[0]) : 0;
              seriesData.value.push(_value);
            });

            let _option = {
              legend: {},
              radar: {
                // shape: 'circle',
                indicator: radarData
              },
              series: [
                {
                  type: "radar",
                  data: [seriesData]
                }
              ]
            };
            console.log(_option);
            // return this.loading = false;
            let _copyData = JSON.parse(JSON.stringify(this.data));
            _copyData.jsonData.eChartData = _option;
            _copyData.json_data = JSON.stringify(_copyData.jsonData);
            if (this.historyResult.length == 0) {
              this.historyResult.push(_copyData.jsonData);
            } else {
              this.historyResult.splice(
                this.showIndex + 1,
                0,
                _copyData.jsonData
              );
            }
            this.changeShowIndex(1);
            this.loading = false;
          } catch (e) {
            console.log(e);
            this.loadNum = 2;
            this.loading = false;
            this.$message.error("生成图表失败");
          }
        });
      } else if (this.data.jsonData.echartsType == "3") {
        //能量柱图
        return this.getContentTable().then(res => {
          try {
            if (res.length <= 0) {
              this.loadNum = 2;
              this.loading = false;
              return this.$message.error("在正文中未找到表格数据");
            }

            let _data = [];
            let stepList = [];
            stepList = this.calculateTopValues(res.length - 1);
            res.forEach((item, index) => {
              if (index == 0) return;
              let _valueItem = item[1] ? item[1] : "0";
              let _value = _valueItem.match(/(\d+)/);
              _value = _value ? parseInt(_value[0]) : 0;
              // 求百分比
              _value = Math.floor((_value / 5).toFixed(2) * 100);
              _data.push({
                value: _value,
                name: item[0],
                title: { offsetCenter: ["0%", `${stepList[index - 1]}%`] },
                detail: {
                  valueAnimation: true,
                  offsetCenter: ["0%", `${stepList[index - 1] + 15}%`]
                }
              });
            });

            let _option = {
              series: [
                {
                  type: "gauge",
                  startAngle: 90,
                  endAngle: -270,
                  pointer: {
                    show: false
                  },
                  progress: {
                    show: true,
                    overlap: false,
                    roundCap: true,
                    clip: false,
                    itemStyle: {
                      borderWidth: 1,
                      borderColor: "#464646"
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      width: 40
                    }
                  },
                  splitLine: {
                    show: false,
                    distance: 0,
                    length: 10
                  },
                  axisTick: {
                    show: false
                  },
                  axisLabel: {
                    show: false,
                    distance: 50
                  },
                  data: _data,
                  title: {
                    fontSize: 14
                  },
                  detail: {
                    width: 50,
                    height: 14,
                    fontSize: 14,
                    color: "inherit",
                    borderColor: "inherit",
                    borderRadius: 20,
                    borderWidth: 1,
                    formatter: "{value}%"
                  }
                }
              ]
            };
            // console.log(stepList)
            // console.log(_option);
            // return (this.loading = false);
            let _copyData = JSON.parse(JSON.stringify(this.data));
            _copyData.jsonData.eChartData = _option;
            _copyData.json_data = JSON.stringify(_copyData.jsonData);
            if (this.historyResult.length == 0) {
              this.historyResult.push(_copyData.jsonData);
            } else {
              this.historyResult.splice(
                this.showIndex + 1,
                0,
                _copyData.jsonData
              );
            }
            this.changeShowIndex(1);
            this.loading = false;
          } catch (e) {
            console.log(e);
            this.loadNum = 2;
            this.loading = false;
            this.$message.error("生成图表失败");
          }
        });
      } else {
        this.loading = false;
        this.loadNum = 2;
        return this.$message.error("该模板不是图表模板");
      }
      this.loadNum = 2;
      this.loading = false;
      return this.$message.error("生成图表失败");
    },
    calculateTopValues(len, minTop = -80, maxTop = 70, maxStep = 40) {
      const length = len;
      const middleIndex = Math.floor(length / 2); // 中间位置的索引
      const totalRange = maxTop - minTop;
      let step = totalRange / (length - 1); // 默认间隔

      // 如果间隔大于 10%，则设置为最大 10%
      if (step > maxStep) {
        step = maxStep;
      }

      const topValues = [];

      // 计算中间元素的top值
      const middleTop = (minTop + maxTop) / 2;
      topValues[middleIndex] = middleTop;

      // 从中间向两边扩展，确保每个元素的top值
      for (let i = middleIndex - 1; i >= 0; i--) {
        topValues[i] = topValues[i + 1] - step; // 向上扩展
      }

      for (let i = middleIndex + 1; i < length; i++) {
        topValues[i] = topValues[i - 1] + step; // 向下扩展
      }

      return topValues;
    },
    getContentTable() {
      return new Promise(resolve => {
        let _content = this.data.jsonData.content;
        const md = new markdownIt();
        let _contentHtml = md.render(_content);

        let _contentTableList = [];
        const rowRegex = /<tr[^>]*>([\s\S]*?)<\/tr>/g; // 匹配表格行，[\s\S] 匹配所有字符
        const cellRegex = /<(th|td)[^>]*>([\s\S]*?)<\/\1>/g; // 匹配单元格，[\s\S] 匹配所有字符

        let rowMatch;
        while ((rowMatch = rowRegex.exec(_contentHtml)) !== null) {
          const rowContent = rowMatch[1]; // 每一行的内容
          const rowData = [];
          let cellMatch;

          // 匹配每个单元格 (th 或 td)
          while ((cellMatch = cellRegex.exec(rowContent)) !== null) {
            let _text = cellMatch[2].trim();
            _text = _text.replace(/&[a-zA-Z]+;/g, "");
            _text = _text.replace(/<\/?[^>]+(>|$)/g, "");
            rowData.push(_text); // 将每个单元格的内容添加到当前行的数组中
          }

          // 如果该行有数据，推送到 _contentTableList 中
          if (rowData.length) {
            _contentTableList.push(rowData);
          }
        }

        // 输出提取的表格数据

        resolve(_contentTableList);
      });
    },
    getRandomColor() {
      // 生成一个随机的 0 到 255 的数字，并将其转换为两位的十六进制形式
      const randomHex = () => {
        const hex = Math.floor(Math.random() * 256).toString(16);
        return hex.length === 1 ? "0" + hex : hex; // 确保每个部分有两位
      };

      // 组合三种颜色（红、绿、蓝）的随机值
      return `#${randomHex()}${randomHex()}${randomHex()}`;
    },
    moveDown(e) {
      if (!this.isDrag) return;
      this.isDragging = true;
      this.startY = e.clientY;
      this.$nextTick(() => {
        this.dialogTagList.forEach(i => {
          this.dragBoxList.push(
            ...this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
              .dragBoxRefTop
          );
          if (
            this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
              .dragBoxRefBottom.length > 0
          ) {
            this.dragBoxList.push(
              ...this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
                .dragBoxRefBottom
            );
          } else if (
            this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
              .dragBoxRefBottom
          ) {
            this.dragBoxList.push(
              this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
                .dragBoxRefBottom
            );
          }
        });
        // 禁用页面文本选择
        document.body.style.userSelect = "none";
        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseup", this.stopDragging);
      });
    },
    onMouseMove(e) {
      if (!this.isDragging) return;

      const newTop = e.clientY - this.startY; // 计算鼠标移动的Y轴距离

      // // 更新div的top样式，使其跟随鼠标移动
      this.moveTop = newTop;
      // this.dragBoxList.forEach(i=>{
      // 	let _i = i.getBoundingClientRect();
      // 	if(e.clientX>=_i.left && e.clientX<=_i.right && e.clientY>=_i.top && e.clientY<=_i.bottom){
      // 		this.enterDrag = i;
      // 		console.log("👇")
      // 		console.log(e)
      // 	}else{
      // 		this.enterDrag = null;
      // 	}
      // })
      // for (let i = 0; i <= this.dragBoxList.length; i++) {
      //   let _i = this.dragBoxList[i].getBoundingClientRect();
      //   if (
      //     e.clientX >= _i.left &&
      //     e.clientX <= _i.right &&
      //     e.clientY >= _i.top &&
      //     e.clientY <= _i.bottom
      //   ) {
      //     this.enterDrag = this.dragBoxList[i];
      //     console.log("👇");
      //     console.log(e);
      // 		break;
      //   } else {
      //     this.enterDrag = null;
      //   }
      // }
    },
    stopDragging(e) {
      this.isDragging = false;
      try {
        const analysisItemRect = this.$refs.analysisItemRef.getBoundingClientRect();
        this.enterDrag = null; // 初始化enterDrag为null
        for (let i = 0; i < this.dragBoxList.length; i++) {
          let _i = this.dragBoxList[i].getBoundingClientRect();
          // 判断this.$refs.analysisItemRef是否与dragBoxList中的某个元素相交
          if (
            analysisItemRect.left < _i.right &&
            analysisItemRect.right > _i.left &&
            analysisItemRect.top < _i.bottom &&
            analysisItemRect.bottom > _i.top
          ) {
            this.enterDrag = this.dragBoxList[i];
            break;
          }
        }
        // 恢复页面的文本选择
        document.body.style.userSelect = "";
        if (!this.enterDrag) {
          this.moveTop = 0;
        } else {
          this.moveTop = 0;
          let moveData = this.enterDrag.getAttribute("type");
          this.$emit("moveAnalysis", {
            form: `${this.data.Type}_${this.index}_${this.data.tIndex}`,
            to: moveData
          });
        }
        // 移除全局的鼠标移动和释放事件
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.stopDragging);
      } catch (error) {
        this.moveTop = 0;
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.stopDragging);
      }
    }
  },
  mounted() {
    if (this.data.jsonData.content) {
      this.historyResult.push(this.data.jsonData);
    }
  }
};
</script>

<style scoped>
.analysisItem {
  width: 100%;
  height: auto;

  /* margin: 11.7px 0px; */

  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  transition: 0.3s;
  background-color: #fff;
  position: relative;
  top: 0;
}

.analysisItem:hover {
  border: 1px solid #3681fc;
}
.text1 {
  color: rgba(54, 129, 252, 1);
}
.text2 {
  color: rgba(23, 196, 105, 1);
}
.ai-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: white;
  border-radius: 5px;
}
.ai-h-left {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  cursor: pointer;
}

.ai-h-l-icon {
  width: 16px;
  height: 16px;
  background: url("../../../../assets/icon/classroomObservation/right.svg")
    no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
  transition: 0.3s;
}

.ai-h-l-iconActive {
  transform: rotate(90deg);
}
.ai-h-l-text {
  font-size: 18px;
}

.ai-h-right {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
}

.ai-h-right > span {
  width: 18px;
  height: 18px;
  background-size: 100% 100%;
  margin: 0 10px;
  cursor: pointer;
}

.ai-h-right > span > img {
  width: 18px;
  height: 18px;
}

.ai-h-r-icon1 {
  background: url("../../../../assets/icon/classroomObservation/back.svg");
  /* 镜像 */
  transform: scaleX(-1);
}

.ai-h-r-icon2 {
  background: url("../../../../assets/icon/classroomObservation/back.svg");
}

.ai_h_r_iconOpacity {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.ai-h-r-icon3 {
  background: url("../../../../assets/icon/classroomObservation/edit.svg");
  /* display: none; */
}

.ai-header:hover .ai-h-r-icon4 {
  display: block;
  /* opacity: 1; */
}

.ai-h-r-icon4 {
  background: url("../../../../assets/icon/classroomObservation/del2.svg");
  /* position: absolute; */
  /* right: -40px; */
  display: none;
  /* opacity: 0; */
  /* transition: .3s; */
}

.analysisItem:hover .ai-h-r-icon4 {
  display: block;
}

.ai-h-r-moveIcon {
  display: none;
  cursor: move !important;
}

.analysisItem:hover .ai-h-r-moveIcon {
  display: block;
}

.ai-h-r-moveIcon > svg {
  width: 18px;
  height: 18px;
}

.ai-main {
  width: 100%;
  height: auto;
  background-color: white;
  border-radius: 0 0 5px 5px;
  overflow: auto;
  box-sizing: border-box;
  padding: 10px 20px;
}

.a-m-brief {
  font-size: 16px;
  /* 斜体 */
  font-style: italic;
  margin-bottom: 10px;
  color: #6b798e;
}

td,
th {
  padding: 10px;
}

.generate {
  color: #00000099;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.generate > img {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.generateSuccess {
  color: #17c469;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.generateSuccess > img {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.generateError {
  color: #e60012;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.a_h_l_edit {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  display: none;
  align-items: center;
  justify-content: center;
}

.a_h_l_edit > img {
  width: 100%;
  height: 100%;
}

.ai-h-left:hover .a_h_l_edit {
  display: flex;
}

.a_h_l_t_input {
  width: 25%;
  min-width: 220px;
  height: 100%;
  display: flex;
  align-items: center;
}

.a_h_l_t_input >>> .el-form {
  width: 100%;
  min-width: 220px;
}

.a_h_l_t_input >>> .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/analysisItem.vue